import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLinkAlt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.3335 8.00008C9.3335 9.84103 7.84111 11.3334 6.00016 11.3334H4.66683C2.82588 11.3334 1.3335 9.84103 1.3335 8.00008C1.3335 6.15913 2.82588 4.66675 4.66683 4.66675H5.00016M6.66683 8.00008C6.66683 6.15913 8.15921 4.66675 10.0002 4.66675H11.3335C13.1744 4.66675 14.6668 6.15913 14.6668 8.00008C14.6668 9.84103 13.1744 11.3334 11.3335 11.3334H11.0002",
		stroke: "#9CD99E",
		strokeLinecap: "round"
	})
});
export default SvgLinkAlt;
